import store from 'store';
import { server_connection } from 'config';

export const GET_MAJOR             = '[MAJOR APP] GET MAJOR';
export const GET_MAJOR_LIST        = '[MAJOR APP] GET MAJOR LIST';
export const DELETE_MAJOR          = '[MAJOR APP] DELETE MAJOR';
export const SAVE_MAJOR            = '[MAJOR APP] SAVE MAJOR';
export const UPDATE_MAJOR_LOADED   = '[MAJOR APP] UPDATE MAJOR LOADED';
export const GET_MAJOR_DATA        = '[MAJOR APP] GET MAJOR DATA';
export const GET_RELATED_DATA      = '[MAJOR APP] GET RELATED DATA';
export const UPDATE_MAJOR_FORM     = '[MAJOR APP] UPDATE MAJOR FORM';
export const GET_MAJOR_ASSET_LIST  = '[MAJOR APP] GET MAJOR ASSET LIST';

// MAJOR -> Course relation
export const GET_ALL_COURSES       = '[MAJOR APP] GET ALL COURSES';
export const TOGGLE_COURSE         = '[MAJOR APP] TOGGLE COURSE';

// MAJOR -> Company relation
export const GET_ALL_COMPANIES     = '[MAJOR APP] GET ALL COMPANIES';
export const TOGGLE_COMPANY        = '[MAJOR APP] TOGGLE COMPANY';
export const UPDATE_ASSET_NAME     = '[MAJOR APP] UPDATE ASSET NAME';

export function updateMajorLoaded(setting) {
    return {
        type: UPDATE_MAJOR_LOADED,
        payload: setting
    }
}

export function updateMajorForm(major_data) {
    return {
        type: UPDATE_MAJOR_FORM,
        payload: major_data
    }
}

export function getMajorData(major_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getMajor(major_id)),
            dispatch(getRelatedData(major_id)),
            dispatch(getAllCourses()),
            dispatch(getAllCompanies()),
            dispatch(getMajorAssetList(major_id)),
        ]).then( 
            () => dispatch(updateMajorLoaded(true))
        )
    }
}

export function getMajor(major_id) {
    return (dispatch, getState) => {
        fetch(server_connection+'/major/get/'+major_id)
            .then((response) => response.json())
            .then((majorData) => {
                dispatch({
                    type: GET_MAJOR,
                    payload: majorData,
                });
            });
    }
}

export function getMajorAssetList(major_id, assetInsertResponse = []) {
    return (dispatch) => {
        fetch(server_connection + '/major/asset_list/' + major_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_MAJOR_ASSET_LIST,
                    payload: {responseData, assetInsertResponse}
                });
            });
    }
}

export function deleteMajor(major_id) {
    return (dispatch, getState) => {
        fetch(server_connection+'/major/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ major_id: major_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: DELETE_MAJOR,
                    payload: major_id,
                });
            });
    }
}

export function saveMajor(major, course_list, company_list, auth_id) {
    const newMajor = { ...major, CreateAuthID: auth_id, LastEditAuthID: auth_id }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/major/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    major: newMajor,
                    course_list: course_list,
                    company_list: company_list,
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getMajorList());
            });

    }
}

export function getMajorList() {
    const auth_id = store.getState().auth.user.data.auth_id
    return (dispatch, getState) => {
        fetch(server_connection+'/major/list/' + auth_id)
            .then((response) => response.json())
            .then((majorList) => {
                dispatch({
                    type: GET_MAJOR_LIST,
                    payload: majorList,
                });
            });
    }
}

//RELATIONAL DATA

export function getRelatedData(major_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/major/data/' + major_id)
            .then((response) => response.json())
            .then((relatedData) => {
                dispatch({
                    type: GET_RELATED_DATA,
                    payload: relatedData
                })
            })
    }
}

export function getAllCourses() {
    const auth_id = store.getState().auth.user.data.auth_id
    return (dispatch) => {
        return fetch(server_connection+'/course/list/' + auth_id)
            .then((response) => response.json())
            .then((allCourses) => {
                return dispatch({
                    type: GET_ALL_COURSES,
                    payload: allCourses
                })
            })
    }
}

export function getAllCompanies() {
    return (dispatch) => {
        return fetch(server_connection+'/company/list')
            .then((response) => response.json())
            .then((allCompanies) => {
                return dispatch({
                    type: GET_ALL_COMPANIES,
                    payload: allCompanies
                })
            })
    }
}

export function toggleCourse(course, action_type) {
    return {
        type: TOGGLE_COURSE,
        payload: {course: course, action_type: action_type}
    }
}

export function toggleCompany(company, action_type) {
    return {
        type: TOGGLE_COMPANY,
        payload: {company: company, action_type: action_type}
    }
}

export function updateAssetName(newName, asset_id, saved) {
    return {
        type: UPDATE_ASSET_NAME,
        payload: {newName, asset_id, saved}
    }
}




// WEBPACK FOOTER //
// src/main/content/major/store/actions/major.actions.js